import React from 'react'

type TermsCheckboxProps = {
  checked: boolean
  onChange: (checked: boolean) => void
  tabIndex?: number
}

const TermsCheckbox = ({ checked, onChange, tabIndex }: TermsCheckboxProps) => (
  <div className="flex items-center">
    <input
      tabIndex={tabIndex}
      id="terms_and_conditions"
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500"
      required
    />
    <label
      htmlFor="terms_and_conditions"
      className="ms-3 text-sm font-medium text-gray-900"
    >
      By signing in you agree to our{' '}
      <a
        href="https://tidyhq.com/terms-of-service/"
        className="text-blue-600 hover:underline"
      >
        Terms&nbsp;and&nbsp;Conditions
      </a>
      .
    </label>
  </div>
)

export default TermsCheckbox
